import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

/**
 * From Stack Overflow --
 * Adapted from Source Code: https://stackoverflow.com/a/56537433
 *
 * Use this directive with `<form>` elements when you want to disable autocomplete
 * Some browsers (ie. Chrome) don't honor our request of `autocomplete=off`...
 * Because it also checks the labels and filling based on that. ex. 'First Name'
 * The solution is to add a zero-width non-joiner: `&zwnj;` after each character of the label. ex. `F&zwnj;i&zwnj;r&zwnj;s&zwnj;t&zwnj; &zwnj;N&zwnj;a&zwnj;m&zwnj;e&zwnj;`
 *
 * @export
 * @class DisableFormAutocompleteDirective
 * @implements {AfterViewInit}
 */
@Directive({
  selector: '[disableFormAutocomplete]',
  standalone: false,
})
export class DisableFormAutocompleteDirective implements AfterViewInit {
  constructor(private renderer: Renderer2, private _el: ElementRef) {}
  ngAfterViewInit() {
    setTimeout(() => {
      const inputs = Array.prototype.slice.call(this._el.nativeElement.querySelectorAll('input'));
      inputs.map((e, i) => {
        this.renderer.setAttribute(e, 'autocomplete', 'off');
      });
      // If you're using mat-form-field
      const labels = Array.prototype.slice.call(
        this._el.nativeElement.querySelectorAll('.mat-form-field-label')
      );
      labels.map((l, i) => {
        l.innerHTML = l.innerHTML.replace(l.textContent, () => {
          // this is a modification to the original code. we want to put the zero-width non-joiner after EACH character
          // only putting after the 1st character results in chrome still being able to determine its an autocomplete field. ex. `E&zwnj;mail Address`
          let label: any = '';
          for (let x = 0; x < l.textContent.length; x++) {
            label += l.textContent[x] + '&zwnj;';
          }
          return label;
        });
      });
    }, 0);
  }
}
